"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    accordionPanelClassNames: function() {
        return accordionPanelClassNames;
    },
    useAccordionPanelStyles_unstable: function() {
        return useAccordionPanelStyles_unstable;
    }
});
const _react = require("@griffel/react");
const accordionPanelClassNames = {
    root: 'fui-AccordionPanel'
};
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        jrapky: 0,
        Frg6f3: 0,
        t21cq0: 0,
        B6of3ja: 0,
        B74szlk: "f1axvtxu"
    }
}, {
    d: [
        [
            ".f1axvtxu{margin:0 var(--spacingHorizontalM);}",
            {
                p: -1
            }
        ]
    ]
});
const useAccordionPanelStyles_unstable = (state)=>{
    'use no memo';
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(accordionPanelClassNames.root, styles.root, state.root.className);
    return state;
}; //# sourceMappingURL=useAccordionPanelStyles.styles.js.map
